import React from "react";
import { Button, Typography } from "@c4c-web/ui";
import { ErrorIcon } from "@c4c-web/icons";
import type { TranslationFn } from "../../../types";
import type { IUseAddressFormSetters } from "../../../hooks";

interface IConfirmAddressErrorMessageProps {
  addressFormSetters: IUseAddressFormSetters;
  t: TranslationFn;
}

export const ConfirmAddressErrorMessage: React.FC<
  IConfirmAddressErrorMessageProps
> = ({ addressFormSetters, t }): JSX.Element => {
  const setErrorAddingAddress = (value: boolean): void => {
    addressFormSetters.setErrorStates((prevStates) => ({
      ...prevStates,
      errorAddingAddress: value,
    }));
  };
  return (
    <div className="flex items-center justify-between gap-md rounded-sm bg-red-500 px-md py-sm">
      <div className="flex items-center gap-md text-white">
        <ErrorIcon color="white" variant="thick" />
        <Typography>{t("addressJourney.error.weRanIntoProblem")}</Typography>
      </div>
      <Button
        className="text-white"
        onClick={() => {
          setErrorAddingAddress(false);
        }}
        variant="ghost"
      >
        <Typography weight="bold">{t("addressJourney.ok")}</Typography>
      </Button>
    </div>
  );
};
